import React from 'react';
import {
	Container,
	GridItem,
	Value,
	IconContentWrapper,
	InsightDetailsWrapper,
	Text,
	GridWrapper,
	KPIIconWrapper,
} from './DynamicGrid.styles';

const DynamicGrid = ({ data }) => {
	const visibleItems = data.filter(item => item.isVisible);
	const itemCount = visibleItems.length;

	const renderGrid = () => {
		let columns, rows;
		let iconWrapperWidth = '15%';
		let valueFontSize = '16px';
		let descriptionFontSize = '12px';
		switch (itemCount) {
			case 4:
				rows = 2;
				columns = 2;
				iconWrapperWidth = '2.1em';
				valueFontSize = '1.4em';
				descriptionFontSize = '0.7em';
				break;
			case 5:
				rows = 2;
				columns = [3, 2]; // 3 columns in the first row, 2 columns in the second row
				iconWrapperWidth = '2.1em';
				valueFontSize = '1.4em';
				descriptionFontSize = '0.7em';
				break;
			case 6:
				rows = 2;
				columns = 3; // 2 rows and 3 columns for 6 items
				iconWrapperWidth = '2.1em';
				valueFontSize = '1.4em';
				descriptionFontSize = '0.7em';
				break;
			case 7:
				rows = 3;
				columns = [2, 2, 3]; // first 2 rows with 2 columns, 3rd row with 3 columns
				iconWrapperWidth = '2.1em';
				valueFontSize = '1.4em';
				descriptionFontSize = '0.7em';
				break;
			case 8:
				rows = 4;
				columns = 2; // 4 rows and 2 columns for 8 items
				iconWrapperWidth = '2.1em';
				valueFontSize = '1.4em';
				descriptionFontSize = '0.7em';
				break;
			case 9:
				rows = 3;
				columns = 3;
				iconWrapperWidth = '2.1em';
				valueFontSize = '1.4em';
				descriptionFontSize = '0.7em';
				break;
			case 10:
				rows = 4;
				columns = [3, 3, 2, 2]; // first 2 rows with 3 columns, last 2 rows with 2 columns
				iconWrapperWidth = '2.1em';
				valueFontSize = '1.4em';
				descriptionFontSize = '0.7em';
				break;
			default:
				rows = 1;
				columns = itemCount;
				iconWrapperWidth = '2.1em';
				valueFontSize = '1.4em';
				descriptionFontSize = '0.7em';
		}

		// TODO: Need to refactor & clean this function
		const renderDescription = (id, description, heading) => {
			if (id === 10) {
				return (
					<Text
						key={`desc-${id}-${descriptionFontSize}`}
						style={{ fontSize: descriptionFontSize, color: '#4B5563' }}
					>
						{description[0]?.length > 0
							? description.join(',')
							: 'No geo location present'}
					</Text>
				);
			} else if (id === 3 && heading == '$0') {
				return (
					<Text
						key={`desc-${id}-${descriptionFontSize}`}
						style={{ fontSize: descriptionFontSize, color: '#4B5563' }}
					>
						{'No business unit present'}
					</Text>
				);
			} else if (id === 8 && heading == '$0') {
				return (
					<Text
						key={`desc-${id}-${descriptionFontSize}`}
						style={{ fontSize: descriptionFontSize, color: '#4B5563' }}
					>
						{'No top cost center present'}
					</Text>
				);
			} else if (description[1] == 'Top 15 Vendor Covers') {
				return (
					<Text
						key={`desc-${id}-special`}
						style={{ fontSize: descriptionFontSize, color: '#4B5563' }}
					>
						{`${description[0]} is covered by top 15 vendors`}
					</Text>
				);
			} else {
				return (
					<Text
						key={`desc-${id}-main`}
						style={{ fontSize: descriptionFontSize, color: '#4B5563' }}
					>
						{description.join(' ')}
					</Text>
				);
			}
		};

		const gridItems = visibleItems.map(
			({ icon: KPIIcon, id, heading, description }) => (
				<GridItem key={id}>
					<IconContentWrapper>
						<KPIIconWrapper
							style={{
								width: heading == 'Benchmarks' ? '1.8em' : iconWrapperWidth,
							}}
						>
							<KPIIcon width="100%" height="100%" />
						</KPIIconWrapper>
						<Value style={{ fontSize: valueFontSize, color: '#111827' }}>
							{heading}
						</Value>
					</IconContentWrapper>
					<InsightDetailsWrapper>
						{renderDescription(id, description, heading)}
					</InsightDetailsWrapper>
				</GridItem>
			)
		);

		// for 5 items: 3 in the first row, 2 in the second row
		if (itemCount === 5) {
			return (
				<GridWrapper>
					<Container rows={1} columns={3}>
						{gridItems.slice(0, 3)}
					</Container>
					<Container rows={1} columns={2}>
						{gridItems.slice(3, 5)}
					</Container>
				</GridWrapper>
			);
		}

		// for 7 items: 2 rows with 2 columns, 3rd row with 3 columns
		if (itemCount === 7) {
			return (
				<GridWrapper>
					<Container rows={1} columns={2}>
						{gridItems.slice(0, 2)}
					</Container>
					<Container rows={1} columns={2}>
						{gridItems.slice(2, 4)}
					</Container>
					<Container rows={1} columns={3}>
						{gridItems.slice(4, 7)}
					</Container>
				</GridWrapper>
			);
		}

		// for 8 items: 4 rows with 2 columns each
		if (itemCount === 8) {
			return (
				<GridWrapper>
					<Container rows={1} columns={2}>
						{gridItems.slice(0, 2)}
					</Container>
					<Container rows={1} columns={2}>
						{gridItems.slice(2, 4)}
					</Container>
					<Container rows={1} columns={2}>
						{gridItems.slice(4, 6)}
					</Container>
					<Container rows={1} columns={2}>
						{gridItems.slice(6, 8)}
					</Container>
				</GridWrapper>
			);
		}

		// for 10 items: First 2 rows with 3 columns, last 2 rows with 2 columns
		if (itemCount === 10) {
			return (
				<GridWrapper>
					<Container rows={1} columns={3}>
						{gridItems.slice(0, 3)}
					</Container>
					<Container rows={1} columns={3}>
						{gridItems.slice(3, 6)}
					</Container>
					<Container rows={1} columns={2}>
						{gridItems.slice(6, 8)}
					</Container>
					<Container rows={1} columns={2}>
						{gridItems.slice(8, 10)}
					</Container>
				</GridWrapper>
			);
		}

		return (
			<Container
				rows={rows}
				columns={Array.isArray(columns) ? columns[0] : columns}
			>
				{gridItems}
			</Container>
		);
	};

	return <>{renderGrid()}</>;
};

export default DynamicGrid;
